module.exports = __webpack_public_path__ + "img/HQ-PA2W1UH_ALL.b3a40300.jpg";